<template>
  <div class="index-slider">
    <h1 v-if="title" class="index-slider-title">
      <span @click="showVt({ field: 'id', order: 3 })">
        <b>{{ title }}</b>
      </span>
      <a href="#" class="index-slider-title-expand" @click.prevent="showVt">
        Skoða fleiri {{ subtitle }}
      </a>
    </h1>
    <!-- Glider -->
    <!--        <div class="glider-contain" style="font-size: 20px;">-->
    <!--            <vue-glide :options="options">-->
    <!--                <vue-glide-slide v-for="(val, index) in scar" :key="index" >-->
    <!--                    <car-->
    <!--                            :key="index"-->
    <!--                            :car="val"-->
    <!--                            :girartegund="girartegund"-->
    <!--                            :index="index"-->
    <!--                            :scrollTop="true"/>-->
    <!--                </vue-glide-slide>-->
    <!--                <template slot="control">-->
    <!--                    <button role="button"-->
    <!--                            aria-label="Previous"-->
    <!--                            class="glider-prev"-->
    <!--                            :class="'glider-prev-' + this.cat_id"-->
    <!--                            data-glide-dir="<"-->
    <!--                    ></button>-->
    <!--                    <button role="button"-->
    <!--                            aria-label="Next"-->
    <!--                            class="glider-next"-->
    <!--                            :class="'glider-next-' + this.cat_id"-->
    <!--                            data-glide-dir=">"-->
    <!--                    ></button>-->

    <!--                </template>-->

    <!--                <div role="tablist" class="dots" :class="'dots-' + this.cat_id"></div>-->
    <!--            </vue-glide>-->
    <!--        </div>-->

    <div class="glider-contain">
      <div class="glider" :class="'glider-' + cat_id + (isCarPage ? ' car-page-glider' : '')" v-if="loaded">
        <car v-for="(val, index) in sliderContent"
             :key="index"
             :car="val"
             :girartegund="girartegund"
             :index="index"
             :scrollTop="true"
             />
      </div>
      <button role="button"
              aria-label="Previous"
              class="glider-prev"
              :class="'glider-prev-' + this.cat_id">

      </button>
      <button role="button"
              aria-label="Next"
              class="glider-next"
              :class="'glider-next-' + this.cat_id">
      </button>
      <div role="tablist" class="dots glider-dots" :class="'dots-' + this.cat_id"></div>
    </div>
  </div>
</template>

<script>
import "babel-polyfill";
import Car from "@/components/global/Car.vue";
import oldCars from "@/mixins/oldCars";
// import {Glide, GlideSlide} from 'vue-glide-js'

export default {
  mixins: [
    oldCars
  ],
  props: {
    title: String,
    subtitle: String,
    cat_id: {
      type: String|Number,
      default: "0"
    },
    scar: [Array, Object],
    girartegund: [Array, Object],
    loaded: {
      type: Boolean,
      default: true
    },
    dealers: {
      type: Boolean,
      default: false
    },
    carsInStock: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      options: {}
    }
  },
  components: {
    Car,
    // [Glide.name]: Glide,
    // [GlideSlide.name]: GlideSlide
  },
  computed: {
    isCarPage() {
      return this.$route.name === 'Car' || this.$route.name === 'DealerCar'
    },
    sliderContent() {
      const pos = this.scar.findIndex(car => car.ad);
      const res = [...this.scar];
      if (
        pos !== -1 &&
        window.matchMedia(`(max-width: 480px)`).matches &&
        !this.isCarPage
      ) res.splice(pos + 1, 0, {...this.scar.find(car => car.ad), hidden: true})

      if (pos !== -1) {
        const ad = res[pos];
        if (window.matchMedia(`(min-width: 1440px)`).matches && window.matchMedia(`(max-width: 1899px)`).matches) {
          res.splice(pos, 1);
          res.splice(3, 0, ad);
        } else if (window.matchMedia(`(min-width: 1300px)`).matches && window.matchMedia(`(max-width: 1339px)`).matches) {
          res.splice(pos, 1);
          res.splice(2, 0, ad);
        } else if (!this.$device.mobile() && window.matchMedia(`(max-width: 1299px)`).matches) {
          res.splice(pos, 1);
          res.splice(1, 0, ad);
        }
      }
      return res;
    }
  },
  mounted() {
    this.init();
  },
  watch: {
    scar: function () {
      let th = this;
      th.init();
      setTimeout(function () {
        th.init();
      }, 3500);
    }
  },
  methods: {
    init() {
      let classSlider = ".glider-" + this.cat_id;
      let classDots = ".dots-" + this.cat_id;
      let classBtnPrev = ".glider-prev-" + this.cat_id;
      let classBtnNext = ".glider-next-" + this.cat_id;

/*
      console.log("init --",[classSlider, document.querySelectorAll(classSlider)]);
      if(!document.querySelector(classSlider)){
        return;
      }

      if(document.querySelectorAll(classSlider).length > 1){
        return;
      }*/

      const dealersResponsive = [
        {
          breakpoint: 0,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2.8,
            slidesToScroll: 2.8
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3.7,
            slidesToScroll: 3.7
          }
        },
        {
          breakpoint: 1440,
          settings: {
            slidesToShow: 4.7,
            slidesToScroll: 4.7
          }
        },
        {
          breakpoint: 1600,
          settings: {
            slidesToShow: 4.7,
            slidesToScroll: 4.7
          }
        },
        {
          breakpoint: 1900,
          settings: {
            slidesToShow: 5.7,
            slidesToScroll: 5.7
          }
        }
      ]

      const dealerResponsive = [
        {
          breakpoint: 0,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2.8,
            slidesToScroll: 2.8
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3.7,
            slidesToScroll: 3.7
          }
        },
        {
          breakpoint: 1440,
          settings: {
            slidesToShow: 4.7,
            slidesToScroll: 4.7
          }
        },
        {
          breakpoint: 1600,
          settings: {
            slidesToShow: 5.7,
            slidesToScroll: 5.7
          }
        },
        {
          breakpoint: 1900,
          settings: {
            slidesToShow: 6.7,
            slidesToScroll: 6.7
          }
        }
      ]

      const dealerInStockResponsive = [
        {
          breakpoint: 0,
          settings: {
            slidesToShow: 1.5,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2.5,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3.5,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 1440,
          settings: {
            slidesToShow: 3.5,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 1600,
          settings: {
            slidesToShow: 4.5,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 1900,
          settings: {
            slidesToShow: 4.5,
            slidesToScroll: 1
          }
        }
      ]

      const selResponsiveOption = this.carsInStock
          ? dealerInStockResponsive
          : this.dealers
              ? dealersResponsive
              : dealerResponsive

        new Glider(document.querySelector(classSlider), {
        //   slidesToShow: 6,
        //   slidesToScroll: 5,
        draggable: true,
        dragVelocity: 1.25,
        duration: 1,
        dots: classDots,
        arrows: {
          prev: classBtnPrev,
          next: classBtnNext
        },
        responsive: selResponsiveOption
      });
    },
    showVt() {
      this.$store.state.filter.fuel_type = [this.cat_id];
      if (window.matchMedia(`(max-width: 575px)`).matches) {
        if (document.querySelector('.page-old-cars')) document.querySelector('.page-old-cars').scrollTo(0, 0)
        if (document.querySelector('.page-dealers-cars')) document.querySelector('.page-dealers-cars').scrollTo(0, 0)
      }
    }
  },
};
</script>
